import { DIFFICULTY_HATS, DIFFICULTY_HINTS, DIFFICULTY_LABELS } from '@cookbook/domain';
import type { Difficulty } from '../api/types.ts';
import { AppIcon } from './AppIcon.tsx';

/** Eigenschaften der Schwierigkeitsanzeige. */
export interface DifficultyBadgeProps {
  readonly difficulty: Difficulty;
  /** Mit Erläuterung, zum Beispiel in Formularen. */
  readonly withHint?: boolean;
}

/** Zeigt die Schwierigkeit als Kochmützen an. */
export function DifficultyBadge({ difficulty, withHint = false }: DifficultyBadgeProps) {
  const hats = DIFFICULTY_HATS[difficulty];

  return (
    <span className="inline-flex items-center gap-2" title={DIFFICULTY_HINTS[difficulty]}>
      <span className="inline-flex items-center" aria-hidden="true">
        {[1, 2, 3].map((index) => (
          <AppIcon
            key={index}
            name="hat"
            size={16}
            className={index <= hats ? 'text-accent' : 'text-border-subtle'}
          />
        ))}
      </span>
      <span className="text-xs text-content-muted">
        {DIFFICULTY_LABELS[difficulty]}
        {withHint ? ` – ${DIFFICULTY_HINTS[difficulty]}` : ''}
      </span>
    </span>
  );
}
